import React, { useMemo } from 'react';
import Box from '../Box';
import Popper from '../Popper';
import Typography from '../Typography';
import Checkbox from '../Checkbox';
const getAsString = (obj, key) => { var _a; return (_a = obj[key]) !== null && _a !== void 0 ? _a : ''; };
const defaultSortFunction = (item1, item2) => item1.toLowerCase().localeCompare(item2.toLowerCase());
const CheckBoxItem = ({ item, keyProp, labelProp, selectedItemIds, onSelect, }) => {
    const key = getAsString(item, keyProp);
    const label = getAsString(item, labelProp);
    const checked = selectedItemIds.has(key);
    const handleChange = () => {
        if (checked) {
            onSelect([...selectedItemIds].filter((selectedKey) => selectedKey !== key));
        }
        else {
            onSelect([...selectedItemIds, key]);
        }
    };
    return (React.createElement(Box, { mb: 16, "data-testid": key, onClick: handleChange },
        React.createElement(Checkbox, { disableOnClick: true, checked: checked, label: React.createElement(Typography, { whiteSpace: "pre-wrap", fontWeight: "regular" }, label) })));
};
const DropdownList = ({ selectAllLabel, isVisible, selectedItemIds, items, keyProp, labelProp, search, anchorRef, yOffset, xOffset, width, height = 350, header, footer, onSelect, onClose, itemsSortFunction = defaultSortFunction, }) => {
    var _a;
    const selectedItemsIdsSet = new Set(selectedItemIds);
    const areAllItemsSelected = useMemo(() => selectedItemIds.length === items.length, [items, selectedItemIds]);
    const filteredItems = useMemo(() => {
        const sortedItems = items.sort((option1, option2) => {
            const stringifiedOption1 = getAsString(option1, labelProp);
            const stringifiedOption2 = getAsString(option2, labelProp);
            return itemsSortFunction(stringifiedOption1, stringifiedOption2);
        });
        if (!search)
            return sortedItems;
        const caseInsensitiveText = search.toLowerCase();
        return sortedItems.filter((item) => {
            const prop = item[labelProp];
            if (typeof prop === 'string') {
                return prop.toLowerCase().includes(caseInsensitiveText);
            }
            return false;
        });
    }, [items, search, labelProp, itemsSortFunction]);
    const handleSelectAll = () => onSelect(selectedItemIds.length !== items.length ? items.map((item) => getAsString(item, keyProp)) : []);
    return (React.createElement(Popper, { open: isVisible, anchorRef: anchorRef, offset: [xOffset !== null && xOffset !== void 0 ? xOffset : 0, yOffset !== null && yOffset !== void 0 ? yOffset : 0], onBlur: onClose }, isVisible && (React.createElement(React.Fragment, null,
        header,
        React.createElement(Box, { maxHeight: height, width: width !== null && width !== void 0 ? width : (_a = anchorRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth, overflowY: "auto", p: 16 },
            selectAllLabel && (React.createElement(Box, { "data-testid": "select-all", onClick: handleSelectAll },
                React.createElement(Checkbox, { disableOnClick: true, checked: areAllItemsSelected, label: React.createElement(Typography, { color: "primary", fontWeight: "regular" }, selectAllLabel) }))),
            React.createElement(Box, { width: "full", height: "1px", bg: "bg.secondary", my: "8px" }),
            filteredItems.map((item) => (React.createElement(CheckBoxItem, { key: getAsString(item, keyProp), selectedItemIds: selectedItemsIdsSet, item: item, keyProp: keyProp, labelProp: labelProp, onSelect: onSelect })))),
        footer))));
};
/**
 * @deprecated
 */
export default DropdownList;
